

/// <reference path="StockNoteProductLine.ts" />

// Generated class InventoryNoteLine_ManagedObject

class InventoryNoteLine_ManagedObject extends StockNoteProductLine
{
}
